<template>
  <div class="s-articles">
    <div class="s-articles__header">
      <div class="s-articles__header__left">
        <div class="e-label">{{ dictionary.articlesLabel }}</div>
        <h1 class="title" v-html="dictionary.articlesTitle"></h1>
      </div>
      <div class="s-articles__header__right">
        <a
          v-if="showMoreLink"
          :href="showMoreLink.url"
          class="btn btn-secondary d-none d-lg-block">
          <span>
            {{ showMoreLink.text }}
          </span>
        </a>
      </div>
    </div>
    <div v-if="records" class="s-articles__main d-none d-lg-grid">
      <div
        v-for="(item, index) in recordsFilteredPaged"
        :key="index"
        class="s-articles__item">
        <ArticleSingle :item="item" />
      </div>
    </div>
    <div v-if="records" class="s-articles__main d-block d-lg-none">
      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-articles__slick"
        :options="slickOptions">
        <!-- @swipe="reset"
        @afterchange="doThis"
        @slick-pause="pause"> -->
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-articles__slick-item">
          <ArticleSingle :item="item" />
        </div>
      </SlickCarousel>
      <a
        v-if="showMoreLink"
        :href="showMoreLink.url"
        class="btn btn-secondary btn--block b-block b-lg-none">
        <span>
          {{ showMoreLink.text }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
import * as lib from './../../lib/lib'
import ArticleSingle from './../components/ArticleSingle.vue'
import SlickCarousel from './../components/common/SlickCarousel.vue'

export default {
  components: { ArticleSingle, SlickCarousel },
  data() {
    return {
      records: [],

      slickKey: 0,
      slickOptions: {
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
      },

      slickActive: null,

      itemsPerPage: this.configuration.itemsPerPage,
      showMoreLink: null,

      // time: 0,
      // timerRunning: false,
    }
  },
  computed: {
    speedInSec() {
      return this.slickOptions.autoplaySpeed / 1000
    },
    recordsFilteredPaged() {
      const start = 0
      const end = this.itemsPerPage
      return this.records.slice(start, end)
    },
  },
  mounted() {
    const { records, showMoreLink } = lib.getData('articlesData')
    this.records = records
    this.showMoreLink = showMoreLink

    this.$nextTick(() => {
      // this.startTimer()
    })
  },
  methods: {
    // reset() {
    //   this.stopTimer()
    // },
    // pause() {
    //   this.timerRunning = false
    // },
    // play() {
    //   this.timerRunning = true
    // },
    // doThis() {
    //   // this.stopTimer()
    //   this.startTimer()
    // },
    // startTimer() {
    //   if (!this.timerRunning) {
    //     this.intervalId = setInterval(() => {
    //       if (this.time < this.slickOptions.autoplaySpeed - 100) {
    //         this.time += 100
    //         this.updateVisual(this.time)
    //       } else {
    //         this.stopTimer()
    //       }
    //     }, 100)
    //     this.timerRunning = true
    //   }
    //   console.log('Start timer')
    // },
    // stopTimer() {
    //   clearInterval(this.intervalId)
    //   this.time = 0
    //   this.updateVisual(this.time)
    //   this.timerRunning = false
    // },
    // updateVisual(time) {
    //   const progress = Math.floor(
    //     (time / this.slickOptions.autoplaySpeed) * 100
    //   )
    //   // const styleElem = document.head.appendChild(
    //   //   document.createElement('style')
    //   // )
    //   // styleElem.innerHTML = `.s-articles__slick .slick-dots .slick-active::after {width: ${progress}%;}`
    // },
  },
}
</script>
<style lang="scss">
.s-articles__slick {
  .slick-dots {
    .slick-active:after {
      transition: all 0.3s;

      content: '';
      position: absolute;
      top: 0;
      left: 0;

      height: 8px;
      width: 0%;
      border-radius: 3px;
      background-color: #ff9840;

      animation: progress v-binds(speedInSec) linear forwards;
    }
  }
}

@keyframes progress {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>
